export default {
  page: {
    title: 'Separador de palavras',
    subtitle: 'Ferramentas',
  },
  card: {
    title: 'Separador de palavras',
  },
  form: {
    text: {
      label: 'Cole o texto aqui',
      placeholder: '',
    },
    minWordLength: {
      label: 'Tamanho mínimo',
      tooltip:
        'Palavras com quantidade de letras menor que esse valor serão ignoradas e não serão contabilizadas no resultado.',
    },
    variations: {
      label: 'Gerar vários:',
    },
    result: {
      label: 'Texto gerado',
      placeholder: 'O texto gerado aparecerá aqui',
    },
    repeatedWords: {
      label: 'Palavras repetidas:',
    },
    totalWords: {
      label: 'Total de palavras:',
    },
  },
  table: {
    group: 'Grupo',
    repeatedWords: 'Palavras repetidas',
    totalWords: 'Total de palavras',
    noContent: 'Ainda não tem nenhum texto gerado.',
  },
  alert: {
    repeatedWord: 'Palavra repetida!',
  },
};
